import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Col, Form } from 'reactstrap'
import { withNamespaces } from 'react-i18next'
import styled from 'styled-components'

import { handleFilterTextChange } from '../../ducks/interactions'
import {
  toggleRequiredAction,
  toggleWorkRequestsApproval
} from '../../ducks/states'
import { setActiveProduct } from '../../ducks/products'

import { Search as SearchIcon } from 'material-react-icons'

import Input from '../../components/Forms/Input'
import Checkbox from '../../components/Forms/Checkbox'
import Select from '../../components/Forms/Select'

const StyledIcon = styled.div`
  cursor: pointer;
`

const StyledCheckboxWrapper = styled.div`
  visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
  margin-top: 8px;
`

const StyledColumn = styled(Col)`
  display: flex;
  flex-direction: row;
`

const StyledLabelValue = styled.div`
  display: flex;
  align-items: center;
  height: 42px;

  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
  font-size: 11px;
  padding-top: 12px;
  background-color: #fff;
  border: 1px solid ${(props) => (props.error ? '#9f2121' : '#ececf0')};
  border-radius: 2px;
  color: #727272;
  padding: 0px 10px;
`

class Search extends Component {
  handleInputChange = (val, debounce) => (ev) => {
    if (typeof val === 'string') {
      this.props.handleFilterTextChange(val, debounce)
    } else {
      this.props.handleFilterTextChange(ev.target.value, debounce)
    }
  }

  handleSubmit = (ev) => {
    ev.preventDefault()
    const { filterText } = this.props.interactions

    this.handleInputChange(filterText, false)()
  }

  renderIcon = () => {
    return (
      <StyledIcon
        onClick={this.handleInputChange(
          this.props.interactions.filterText,
          false
        )}
      >
        <SearchIcon color="#8B93A7" />
      </StyledIcon>
    )
  }

  renderSearchField = () => {
    const { t } = this.props
    const { filterText } = this.props.interactions

    return (
      <Form onSubmit={this.handleSubmit}>
        <Input
          input={{
            name: 'search',
            id: 'search',
            type: 'text',
            placeholder: t('tickets:search'),
            value: filterText,
            onChange: this.handleInputChange(null, true)
          }}
          renderIcon={this.renderIcon}
        />
      </Form>
    )
  }

  handleProductSelect = (ev) => {
    const { value } = ev.target
    this.props.setActiveProduct(value)
  }

  renderProductSelector = () => {
    const { t } = this.props
    const { entities, selectedProductId, loading, error } = this.props.products
    const { selectedPropertyId } = this.props.properties

    if (!selectedPropertyId) return null

    if (entities.length === 0) {
      return (
        <StyledLabelValue error>{t('product:noProducts')}</StyledLabelValue>
      )
    }

    if (entities.length === 1) {
      return <StyledLabelValue>{entities[0].name}</StyledLabelValue>
    }

    const options = [
      {
        label: t('product:allProducts'),
        value: ''
      },
      ...entities.map(({ name, product_id }) => ({
        label: name,
        value: product_id
      }))
    ]

    return (
      <Select
        value={selectedProductId}
        disabled={loading || error}
        onChangeCallback={this.handleProductSelect}
        options={options}
      />
    )
  }

  renderRequiredCheckbox = () => {
    const { t, toggleRequiredAction } = this.props
    const { onlyRequiredAction } = this.props.states

    return (
      <StyledCheckboxWrapper>
        <Checkbox
          input={{
            name: 'onlyRequired',
            value: onlyRequiredAction,
            onChange: toggleRequiredAction
          }}
          label={t('states:onlyRequired')}
        />
      </StyledCheckboxWrapper>
    )
  }

  renderWorkRequestsCheckbox = () => {
    const {
      t,
      toggleWorkRequestsApproval,
      toggleWorkRequestsVisible
    } = this.props
    const { onlyWorkRequestsApproval } = this.props.states
    const { can_approve_wr = true } = this.props.profile

    return (
      <StyledCheckboxWrapper hidden={!can_approve_wr}>
        <Checkbox
          input={{
            name: 'onlyWorkRequests',
            value: onlyWorkRequestsApproval,
            onChange: toggleWorkRequestsApproval
          }}
          label={t('states:onlyWorkRequests')}
        />
      </StyledCheckboxWrapper>
    )
  }

  render() {
    return (
      <React.Fragment>
        <Col md={4}>{this.renderSearchField()}</Col>
        <Col md={4}>{this.renderProductSelector()}</Col>
        <StyledColumn md={4}>
          {this.renderRequiredCheckbox()}
          {this.renderWorkRequestsCheckbox()}
        </StyledColumn>
      </React.Fragment>
    )
  }
}

export default compose(
  connect(
    ({ interactions, states, products, properties, profile }) => ({
      properties,
      products,
      interactions,
      states,
      profile
    }),
    {
      handleFilterTextChange,
      toggleRequiredAction,
      setActiveProduct,
      toggleWorkRequestsApproval
    }
  ),
  withNamespaces()
)(Search)
